import api from 'api/api'

export const GET_USER_VOUCHER_FOR_SALE = '[USER VOUCHERS] GET USER VOUCHERS FOR SALE'

export function getUserVouchersForSaleAction() {
  const request = api.get('/user-vouchers/for-sale')
  return (dispatch) => {
    dispatch({ type: GET_USER_VOUCHER_FOR_SALE, payload: { loading: true } })
    request.then((response) => {
      dispatch({ type: GET_USER_VOUCHER_FOR_SALE, payload: { data: response.data.data } })
    }).catch((error) => {
      console.log(GET_USER_VOUCHER_FOR_SALE, error)
    }).finally(() => {
      dispatch({ type: GET_USER_VOUCHER_FOR_SALE, payload: { loading: false } })
    })
  }
}
